module.exports = {"ru":{"ds":{"modal":{"ok":"Ok","cancel":"Отменить"}}}}